import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {SharedBoardsClient} from '@client/shared-boards-client'
import {useClickOut} from '@components/click-out'
import {InputNew} from '@components/common/base/input-new'
import {MoveToBody} from '@components/move-to-body'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {useOnWindowResize} from '@containers/hooks'
import {SearchFilter} from './search-filter'
import {useSearchPopupStore} from './search-popup-store'
import {SearchProgress} from './search-progress'
import {SearchResultsNew} from './search-results-new'
import {useSearchStore} from './search-store'

const TwSearchPopup = tw.div`
  min-h-[360px]
  p-8
  flex
  flex-col
  gap-8
  rounded-8
  overflow-hidden
  bg-background-primary
  shadow-md
`

export const TwSearchDivider = tw.div`
  border-solid
  border-0
  border-b-1
  -ml-8
  w-[calc(100%+16px)]
  border-line-base
`

export const SearchPopup = observer(() => {
  const [state, store] = useSearchStore()
  const [popupState, popupStore] = useSearchPopupStore()

  const ref = useRef<HTMLElement>(null)
  useClickOut({ref, cb: popupStore.tryHidePopup, capture: true})

  const placeholder = SharedBoardsClient.getId()
    ? Lang.msg.share.searchBoard
    : Lang.msg.searchCompany

  useOnWindowResize(popupStore.tryRepositionPopup)
  useEffect(() => {
    popupStore.tryRepositionPopup()
  }, [
    rightPanelStore.state.chatPanel.opened,
    rightPanelStore.state.chatPanel.width
  ])

  return (
    <MoveToBody zIndex={1000} left={popupState.popupX} top={popupState.popupY}>
      <TwSearchPopup
        ref={ref}
        style={{
          width: popupState.popupWidth,
          maxHeight: popupState.popupHeight
        }}
      >
        <InputNew
          ref={store.setInputEl}
          iconLeft="IconSearch"
          iconRight={state.value ? 'IconX' : undefined}
          onIconRightClick={() => store.setValue('')}
          placeholder={placeholder}
          onChange={store.setValue}
          value={state.value}
          onFocus={store.startSearch}
          autoFocus
        />
        <SearchFilter />
        <TwSearchDivider />
        <SearchProgress />
        <SearchResultsNew refreshChangedProject />
      </TwSearchPopup>
    </MoveToBody>
  )
})
